import styled from '@emotion/styled'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'

import { useCallbackOnVisibilityChange } from '~/@common/hooks/useCallbackOnVisibilityChange'
import { useRepository } from '~/@common/hooks/useRepository'
import { commonRepo } from '~/@common/services/repo.service'
import { mediaQuery } from '~/@common/styles/mediaQuery'

import {
  LECTURE_STATUS_FILTER,
  LectureService,
  type LectureStatusFilter,
} from './@service/Lecture.service'
import AssignedLectureList from './@widgets/AssignedLectureList.widget'
import LectureGroupHeader from './@widgets/LectureGroupHeader.widget'
import LectureGroupList from './@widgets/LectureGroupList.widget'

let init = false

const LectureListPage = () => {
  useCallbackOnVisibilityChange()

  const service = useRepository(LectureService)

  const [lectureStatusFilter, setLectureStatusFilter] = useState<LectureStatusFilter>(
    LECTURE_STATUS_FILTER.ALL,
  )

  useEffect(() => {
    if (!commonRepo.curriculumCore || !commonRepo.studentId || !service.selectedCurriculumInfo) {
      return
    }
    if (init) return
    service.setCurriculumAndFetchLectureGroups({
      curriculumInfo: service.selectedCurriculumInfo,
      studentId: commonRepo.studentId,
    })
    init = true
  }, [commonRepo.studentId, service.selectedCurriculumInfo])

  if (!service.selectedCurriculumInfo) {
    return <></>
  }

  return (
    <S.LectureListPage>
      <LectureGroupHeader
        isShowAllLectures={service.isShowAllLectures}
        onToggleShowAllLectures={service.toggleShowAllLectures}
        lectureStatusFilter={lectureStatusFilter}
        onChangeLectureStatusFilter={setLectureStatusFilter}
      />
      {service.isShowAllLectures ? (
        <LectureGroupList lectureGroups={service.lectureGroups} isFetching={service.isFetching} />
      ) : (
        <AssignedLectureList lectureStatusFilter={lectureStatusFilter} />
      )}
    </S.LectureListPage>
  )
}

export default observer(LectureListPage)

const S = {
  LectureListPage: styled.div`
    display: flex;
    gap: 20px;
    flex-direction: column;
    height: 100%;

    ${mediaQuery.underTablet} {
      margin-top: 10px;
    }
  `,
}
